module.exports = __webpack_public_path__ + "static/media/disperss.96ecf190.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/cenicilla_fresa/preventiva/disperss.png
// module id = 1549
// module chunks = 3